import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Building2, Package, Ticket, LifeBuoy, ScrollText, LogOut, Shield, CreditCard, UserCog, TrendingUp, Users, Settings, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Toaster } from "@/components/ui/sonner";

const NAV = [
  { to: "/admin-master", icon: LayoutDashboard, label: "Dashboard", end: true, tid: "admin-nav-dashboard" },
  { to: "/admin-master/metricas", icon: TrendingUp, label: "Métricas SaaS", tid: "admin-nav-metrics" },
  { to: "/admin-master/leads", icon: Users, label: "Leads e retenção", tid: "admin-nav-leads" },
  { to: "/admin-master/empresas", icon: Building2, label: "Empresas", tid: "admin-nav-tenants" },
  { to: "/admin-master/planos", icon: Package, label: "Planos", tid: "admin-nav-plans" },
  { to: "/admin-master/pagamentos", icon: CreditCard, label: "Pagamentos", tid: "admin-nav-payments" },
  { to: "/admin-master/configuracoes", icon: Settings, label: "Configurações", tid: "admin-nav-settings" },
  { to: "/admin-master/conteudo", icon: FileText, label: "Conteúdo", tid: "admin-nav-content" },
  { to: "/admin-master/cupons", icon: Ticket, label: "Cupons", tid: "admin-nav-coupons" },
  { to: "/admin-master/suporte", icon: LifeBuoy, label: "Suporte", tid: "admin-nav-support" },
  { to: "/admin-master/logs", icon: ScrollText, label: "Auditoria", tid: "admin-nav-audit" },
  { to: "/admin-master/conta", icon: UserCog, label: "Minha conta", tid: "admin-nav-account" },
];

export function AdminShell() {
  const nav = useNavigate();
  const logout = () => { localStorage.removeItem("pg_admin_token"); nav("/admin-master/login"); };
  return (
    <div className="admin-dark min-h-screen bg-zinc-950 text-white">
      <div className="flex">
        <aside className="hidden lg:flex w-64 flex-col border-r border-zinc-800 bg-zinc-950 min-h-screen sticky top-0">
          <div className="px-6 py-6 border-b border-zinc-800 flex items-center gap-2">
            <div className="h-9 w-9 rounded-xl bg-emerald-500 grid place-items-center"><Shield className="h-5 w-5 text-zinc-950" /></div>
            <div>
              <div className="font-display font-bold text-white">Admin Master</div>
              <div className="text-xs text-emerald-400">Portal Gestão</div>
            </div>
          </div>
          <nav className="flex-1 p-3 space-y-1">
            {NAV.map((it) => (
              <NavLink key={it.to} to={it.to} end={it.end} data-testid={it.tid}
                className={({ isActive }) =>
                  `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition ${
                    isActive ? "bg-emerald-500/10 text-emerald-400 border border-emerald-500/30" : "text-zinc-400 hover:bg-zinc-900 hover:text-white"
                  }`}>
                <it.icon className="h-4 w-4" /> {it.label}
              </NavLink>
            ))}
          </nav>
          <div className="p-4 border-t border-zinc-800">
            <Button variant="outline" size="sm" className="w-full gap-2 border-zinc-700 bg-zinc-900 text-white hover:bg-zinc-800" onClick={logout} data-testid="admin-logout">
              <LogOut className="h-4 w-4" /> Sair
            </Button>
          </div>
        </aside>
        <main className="flex-1 min-w-0 p-4 md:p-8"><Outlet /></main>
      </div>
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
}
